var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import DialogContentText from '@mui/material/DialogContentText';
import { ButtonRounded } from '../buttons';
import { Dialog, DialogTitle, DialogContent, CloseButton, DialogActions, Flag, } from './styledComponents';
import { DotPulseLoader } from '../loaders';
export var Modal = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.position, position = _d === void 0 ? 'center' : _d, _e = _a.onCancel, onCancel = _e === void 0 ? null : _e, _f = _a.onConfirmation, onConfirmation = _f === void 0 ? null : _f, _g = _a.onDismiss, onDismiss = _g === void 0 ? null : _g, _h = _a.flag, flag = _h === void 0 ? '' : _h, _j = _a.title, title = _j === void 0 ? '' : _j, _k = _a.content, content = _k === void 0 ? '' : _k, _l = _a.confirmButtonText, confirmButtonText = _l === void 0 ? 'OK' : _l, _m = _a.cancelButtonText, cancelButtonText = _m === void 0 ? 'CANCEL' : _m, dialogProps = __rest(_a, ["isOpen", "isLoading", "position", "onCancel", "onConfirmation", "onDismiss", "flag", "title", "content", "confirmButtonText", "cancelButtonText"]);
    return (<Dialog id="modal" open={isOpen} keepMounted aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description" fullWidth onClose={onCancel ? onCancel : function () { }} position={position} {...dialogProps}>
      <DialogTitle id="alert-dialog-slide-title">
        {title}
        {onDismiss ? <CloseButton onClick={onDismiss}>×</CloseButton> : null}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {typeof content === 'string' ? (<>
              {flag ? <Flag id="flag">{flag}</Flag> : null}
              <span style={{ fontSize: '16px', fontWeight: 300 }} id="content" dangerouslySetInnerHTML={{ __html: content }}></span>
            </>) : (content)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {onCancel && (<ButtonRounded disabled={isLoading} id="cancel-btn" colorVariant="tertiary" onClick={onCancel}>
            {cancelButtonText}
          </ButtonRounded>)}
        {isLoading ? (<DotPulseLoader id="loader" style={{ margin: '0px 36px' }}/>) : (onConfirmation && (<ButtonRounded id="confirm-btn" onClick={onConfirmation} disabled={isLoading}>
              {confirmButtonText}
            </ButtonRounded>))}
      </DialogActions>
    </Dialog>);
};
